import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const DragIndicatorIcon = ({ color, height, viewBox, width, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                fill={color}
                d="M9,20c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41s.2-1.02.59-1.41c.39-.39.86-.59,1.41-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.02-.59,1.41c-.39.39-.86.59-1.41.59ZM15,20c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41s.2-1.02.59-1.41c.39-.39.86-.59,1.41-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.02-.59,1.41c-.39.39-.86.59-1.41.59ZM9,14c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41s.2-1.02.59-1.41c.39-.39.86-.59,1.41-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.02-.59,1.41c-.39.39-.86.59-1.41.59ZM15,14c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41s.2-1.02.59-1.41c.39-.39.86-.59,1.41-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.02-.59,1.41c-.39.39-.86.59-1.41.59ZM9,8c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41s.2-1.02.59-1.41c.39-.39.86-.59,1.41-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.02-.59,1.41c-.39.39-.86.59-1.41.59ZM15,8c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41s.2-1.02.59-1.41c.39-.39.86-.59,1.41-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.02-.59,1.41c-.39.39-.86.59-1.41.59Z"
            />
        </SvgIcon>
    );
};

DragIndicatorIcon.propTypes = {
    color: string,
    height: string,
    viewBox: string,
    width: string,
};

DragIndicatorIcon.defaultProps = {
    color: MIGRATED_COLORS.black,
    height: '24px',
    viewBox: '0 0 24 24',
    width: '24px',
};

export default DragIndicatorIcon;
